module.exports = __webpack_public_path__ + "img/N110-2-EN.13c88e3b.png";